"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestDeployer__factory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "Paused",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "Unpaused",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "salt",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "codeHash",
                type: "bytes32",
            },
        ],
        name: "computeAddress",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "salt",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "codeHash",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "deployer",
                type: "address",
            },
        ],
        name: "computeAddressWithDeployer",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
            {
                internalType: "bytes32",
                name: "salt",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "code",
                type: "bytes",
            },
        ],
        name: "deploy",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
            {
                internalType: "bytes32",
                name: "salt",
                type: "bytes32",
            },
        ],
        name: "deployERC1820Implementer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address payable",
                name: "payoutAddress",
                type: "address",
            },
        ],
        name: "killCreate2Deployer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "paused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "unpause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        stateMutability: "payable",
        type: "receive",
    },
];
const _bytecode = "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";
class RequestDeployer__factory extends ethers_1.ContractFactory {
    constructor(signer) {
        super(_abi, _bytecode, signer);
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.RequestDeployer__factory = RequestDeployer__factory;
RequestDeployer__factory.bytecode = _bytecode;
RequestDeployer__factory.abi = _abi;
